"use strict";
const EDITABLE_STATES = [
  "draft",
  "exception",
  "needs_indexing"
];
export function readOnly(factorInvoice) {
  if (!factorInvoice) return false;
  const state = factorInvoice.state;
  if (state && !EDITABLE_STATES.includes(state)) return true;
  return factorInvoice.source_system !== "hubtran";
}
